class BrazeModal {
  constructor() {
    this.initBrazeModal();
  }

  initBrazeModal() {
    const brazeContainer = document.querySelector('.braze__container');
    if (!brazeContainer) return;

    const isShowPopupDefault = brazeContainer.getAttribute('data-is-show-popup-default') == 'true';
    if (isShowPopupDefault) {
      brazeContainer.classList.add('animate', 'active');
    } else {
      const brazeLabel = document.querySelector('.braze__label');
      if (!brazeLabel) return;

      brazeLabel.addEventListener('click', () => {
        brazeContainer.classList.add('animate', 'active');
      });
    }

    const brazeClose = brazeContainer.querySelector('.drawer__close');
    if (!brazeClose) return;

    brazeClose.addEventListener('click', this.close.bind(this));

    const overlay = document.querySelector('#Braze-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
  }

  close() {
    const brazeContainer = document.querySelector('.braze__container');
    if (brazeContainer) {
      brazeContainer.classList.remove('active');
    }
    document.body.classList.remove('overflow-hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BrazeModal();
});
